import { handBack } from '../ability/context.js';
import type { PortEnv } from '../port-contract.js';

/** A resolution-local, dependency-only port environment. Unknown seams refuse;
 * they never fabricate a read result or execute persistence outside truth commits. */
export function browserDependencies<D extends object>(deps: D, globals: Record<string, unknown> = {}): PortEnv<D> {
  return new Proxy({ deps, globals, functionStatics: {} }, {
    get: (target, name) => typeof name === 'symbol' ? Reflect.get(target, name) : name in target ? target[name as keyof typeof target]
      : handBack(`k4-dispatch:environment:${String(name)}`),
  }) as PortEnv<D>;
}
